<template>
  <menu-dropdown
    class="main-menu-report-tabs-mobile-dropdown"
    :open="store.mobile.menuReportTabsOpen"
    :top="store.mobile.menuReportTabsTop"
    :items="reportTabs"
    dropdown-class="main-menu-report-tabs-mobile-dropdown__content"
    @click-outside="handleClickOutside"
  >
    <template #select="scrollPosition">
      <main-menu-report-tabs-mobile-item
        v-if="scrollPosition <= 0"
        :item="currentCommonTabProps"
        type="dropdown"
        :decorative-dropdown="true"
        @click="handleMainSelectClick"
      ></main-menu-report-tabs-mobile-item>
    </template>
    <template #item="item">
      <main-menu-report-tabs-mobile-item
        :item="item"
        :bookmark-indexes="bookmarkIndexes"
        @click="handleAction(item)"
        @close="handleClose"
      ></main-menu-report-tabs-mobile-item>
    </template>
  </menu-dropdown>
</template>

<script setup lang="ts">
import { useStore } from '@/store';

const store = useStore();
  import MenuDropdown from '@/components/menu-dropdown.vue';
  import MainMenuReportTabsMobileItem from '@/views/layout/navigation/grouping/main-menu-report-tabs-mobile-item.vue';
  import { useReportTabs } from '@/composables';
  import type { ReportTab } from '@/views/reports/views/report-tab.types';
  const {
    reportTabs,
    bookmarkIndexes,
    currentCommonTabProps,
  } = useReportTabs();

  const close = () => {
    store.setMenuReportTabsOpen(false);
  };

  const handleMainSelectClick = () => {
    close();
  };

  const handleAction = (tab: ReportTab) => {
    if (tab.click) {
      tab.click();
    }
    close();
  };

  const handleClose = (redirect: boolean) => {
    if (redirect) {
      close();
    }
  };

  const handleClickOutside = () => {
    if (store.mobile.menuReportTabsOpen) {
      close();
    }
  };
</script>

<style lang="scss">
.main-menu-report-tabs-mobile-dropdown {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background-color: var(--color-bluedeep);
  overflow: auto;

  &__icon {
    font-size: 12px;
  }

  &__content {
    border-top: 1px solid var(--color-white20);
  }
}
</style>
